import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getImageSize, getInitialStyle, defaultContext } from './avatar.style';
import { getProfilePhotoUrl } from './avatar.utils';

export default class Avatar extends Lightning.Component {
  static _template() {
    return _merge(
      {
        rtt: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  set photoId(imageId) {
    if (!imageId) {
      return;
    }

    this.patch({
      src: getProfilePhotoUrl({
        imageId,
        ...getImageSize(this._style.screenSize),
      }),
    });
  }
}
